"use client";

import * as React from "react";

export interface PageContainerProps {
  children: React.ReactNode;
}

export function PageContainer({ children }: PageContainerProps) {
  return (
    <div className="relative mx-auto min-h-screen max-w-7xl space-y-6 px-3 pb-3 text-slate-900 dark:text-zinc-50 md:px-6 md:pb-6">
      {children}
    </div>
  );
}
